import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Chat from '../views/Chat.vue'
import Config from '../views/Config.vue'
import Agent from '../views/Agent.vue'
import Admin from '../views/Admin.vue'
import Connect from '../views/Connect.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/chat',
    name: 'Lebot',
    component: Chat
  },
  {
    path: '/chat/:id',
    name: 'LebotId',
    component: Chat
  },
  {
    path: '/config',
    name: 'Config',
    component: Config
  },
  {
    path: '/agents',
    name: 'Agentes',
    component: Agent
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/conectar',
    name: 'Connect',
    component: Connect
  }
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router
